import { Modal } from "antd";
import { useFormik } from "formik";
import { useEffect, memo } from "react";
import { useSelector } from "react-redux";
import { deleteDocument } from "../../redux/EngageTranslation/EngageTranslationAction";
import { RootState } from "../../redux/Store";
import { useAppDispatch } from "../../redux/useAppDispatch";
import { folderDeleteValidationScheme } from "../../schemas/formValidationScheme";
import { useNavigate } from "react-router";
type FileUploadModalProps = {
  close: () => void;
  openState: boolean;
  open: () => void;
};
function ConfirmLogoutModal(props: FileUploadModalProps) {
  const navigate = useNavigate();

  const ConfirmLogoutModalContent = () => {
    function logout() {
      navigate("/");
      props.close();
    }

    // console.log(errors);
    return (
      <div
        className="d-flex flex-column justify-content-between gap-4 h-100 needs-validation"
        id="createNewFolderForm">
        <h4>Logout</h4>
        <div className="d-flex flex-column gap-1">
          <p>Are you sure you want to logout?</p>
          <div className="d-flex gap-4 justify-content-end">
            <button
              className="button"
              onClick={() => logout()}>
              Confirm
            </button>
            <button
              type="button"
              onClick={() => props.close()}
              // form="createNewFolderForm"
              className="button warning">
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  };
  //   const FileUploadModalWidth = "30%";
  return (
    <Modal
      //   width={FileUploadModalWidth}
      centered
      zIndex={10000}
      footer={[]}
      onCancel={() => props.close()}
      open={props.openState}>
      <ConfirmLogoutModalContent />
    </Modal>
  );
}

export default memo(ConfirmLogoutModal);
